(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-blog"] && !Shopify.designMode) return;
  try {
      
document.querySelectorAll('[id^="shopify-section-"]').forEach((card, index) => {
   console.log = function(){};
   if(card.classList.contains('featured-blog')) {     
    const topHeading = card.querySelectorAll('.for-arrow-alignment');      
    if(topHeading.length === 0) return;
    const cardHeight = parseInt(topHeading[0].clientHeight);
    const topValue = cardHeight / 2 + 5;
    const cardTopCSS = "calc(50% - "+topValue+'px)';     
    const swiperContainer = card.querySelector('.swiper');    
     if(!swiperContainer) return;
    const swiperPrevElement = swiperContainer.querySelector('.swiper-button-prev');    
    const swiperNextElement = swiperContainer.querySelector('.swiper-button-next');     
    if(!swiperPrevElement || !swiperNextElement) return
    swiperPrevElement.setAttribute('style', 'top:'+cardTopCSS);    
    swiperNextElement.setAttribute('style', 'top:'+cardTopCSS);
  }        
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
              $('.loading-image').removeClass('loading-image').addClass('loaded-image');
              let sameCard = document.querySelector('.from-recommended');

              if (typeof initSwiperSliders === 'function') {
                initSwiperSliders();
              }
              
              let swiperContainer = this.querySelector('.product-recommendations .swiper');
              if (swiperContainer) {
                let swiperPrevElement = swiperContainer.querySelector('.swiper-button-prev');
                let swiperNextElement = swiperContainer.querySelector('.swiper-button-next');
                
                if (sameCard) {
                  let cardHeight = parseInt(sameCard.clientHeight);
                  let topValue = cardHeight / 2 + 5;
                  let cardTopCSS = `calc(50% - ${topValue}px)`;

                  if (swiperPrevElement) swiperPrevElement.setAttribute('style', `top:${cardTopCSS}`);
                  if (swiperNextElement) swiperNextElement.setAttribute('style', `top:${cardTopCSS}`);
                }
              }
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  function initSwiperSliders() {
    document.querySelectorAll('[data-swiper-slider]').forEach(function(swiperElement) {
      if (!swiperElement.swiper) {
        const sliderOptionsContainer = swiperElement.closest('[data-slider-options]');
        if (sliderOptionsContainer) {
          const sliderOptions = JSON.parse(sliderOptionsContainer.dataset.sliderOptions);
          
          sliderOptions.loop = (sliderOptions.loop === 'true');
          
          sliderOptions.slidesPerView = sliderOptions.desktop;
          sliderOptions.spaceBetween = 20;

          sliderOptions.breakpoints = {
            320: { // mobile
              slidesPerView: 1.5, // Show 1.5 slides (first full, second half)
              spaceBetween: 10,
              slidesOffsetAfter: 0, // No extra offset
              centeredSlides: false, // Align slides to left
              initialSlide: 0 // Start at first slide
            },
            750: { // tablet
              slidesPerView: sliderOptions.tablet,
              spaceBetween: 15
            },
            990: { // laptop
              slidesPerView: sliderOptions.laptop,
              spaceBetween: 20
            },
            1200: { // desktop
              slidesPerView: sliderOptions.desktop,
              spaceBetween: 20
            }
          };

          if (swiperElement.closest('recommendation-slider').querySelector('.swiper-button-next')) {
            sliderOptions.navigation = {
              nextEl: swiperElement.closest('recommendation-slider').querySelector('.swiper-button-next'),
              prevEl: swiperElement.closest('recommendation-slider').querySelector('.swiper-button-prev'),
            };
          }
          if (swiperElement.closest('recommendation-slider').querySelector('.swiper-pagination')) {
            sliderOptions.pagination = {
              el: swiperElement.closest('recommendation-slider').querySelector('.swiper-pagination'),
              clickable: true,
            };
          }

          if (parseInt(sliderOptions.auto_play) > 0) {
            sliderOptions.autoplay = {
              delay: parseInt(sliderOptions.auto_play) * 1000,
              disableOnInteraction: false,
            };
          } else {
            delete sliderOptions.autoplay;
          }

          swiperElement.swiper = new Swiper(swiperElement, sliderOptions);
        }
      } else {
        swiperElement.swiper.update();
      }
    });
  }

  document.addEventListener('DOMContentLoaded', initSwiperSliders);

  } catch(e) { console.error(e); }
})();
})();
